import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import academicModal from "models/academic.modal";
import { helper } from "lib/helper";
import Loader from "components/loader/Loader";
import axios from "axios";
import Swal from "sweetalert2";
import ProductModal from "models/Product.modal";

const AddProduct = () => {
  const [formData, setFormData] = useState({
    productName: '',
    bannerImage: null,
    priceNormal: '',
    discountPrice: '',
    productImage1: null,
    productImage2: null,
    productImage3: null,
    productImage4: null,
    productDescription: '',
  });

  console.log(formData, "formDatassss")
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const { name } = e.target;
    const file = e.target.files[0];
    setFormData({ ...formData, [name]: file });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const data = new FormData();
    data.append('name', formData.productName);
    data.append('banner', formData.bannerImage);
    data.append('normal_price', formData.priceNormal);
    data.append('discounted_price', formData.discountPrice);
    data.append('image1', formData.productImage1);
    data.append('image2', formData.productImage2);
    data.append('image3', formData.productImage3);
    data.append('image4', formData.productImage4);
    data.append('description', formData.productDescription);

    try {
      const response = await ProductModal.Add(data);
      Swal.fire('Success', response.data.message, 'success');
      navigate('/admin/product');
    } catch (error) {
      console.error('There was an error uploading the file!', error);
      Swal.fire('Error', 'There was a problem saving the product', 'error');
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Container className="pt-7">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">
                  <span>Add Product</span>
                </h3>
              </CardHeader>

              <CardBody>
                <div>
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="productName">Product Name</Label>
                          <Input
                            id="productName"
                            name="productName"
                            placeholder="Enter Name"
                            value={formData.productName}
                            onChange={handleInputChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="bannerImage">Banner Image</Label>
                          <Input
                            style={{
                              border: '1px solid lightgrey',
                              padding: '6px 10px',
                              borderRadius: '6px',
                            }}
                            id="bannerImage"
                            name="bannerImage"
                            type="file"
                            onChange={handleFileChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="priceNormal">Price (Normal)</Label>
                          <Input
                            id="priceNormal"
                            name="priceNormal"
                            placeholder="Enter Amount"
                            type="number"
                            value={formData.priceNormal}
                            onChange={handleInputChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="discountPrice">Discount Price</Label>
                          <Input
                            id="discountPrice"
                            name="discountPrice"
                            placeholder="Enter Discount Amount"
                            type="number"
                            value={formData.discountPrice}
                            onChange={handleInputChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="productImage1">Product Image 1</Label>
                          <Input
                            style={{
                              border: '1px solid lightgrey',
                              padding: '6px 10px',
                              borderRadius: '6px',
                            }}
                            id="productImage1"
                            name="productImage1"
                            type="file"
                            onChange={handleFileChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="productImage2">Product Image 2</Label>
                          <Input
                            style={{
                              border: '1px solid lightgrey',
                              padding: '6px 10px',
                              borderRadius: '6px',
                            }}
                            id="productImage2"
                            name="productImage2"
                            type="file"
                            onChange={handleFileChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="productImage3">Product Image 3</Label>
                          <Input
                            style={{
                              border: '1px solid lightgrey',
                              padding: '6px 10px',
                              borderRadius: '6px',
                            }}
                            id="productImage3"
                            name="productImage3"
                            type="file"
                            onChange={handleFileChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="productImage4">Product Image 4</Label>
                          <Input
                            style={{
                              border: '1px solid lightgrey',
                              padding: '6px 10px',
                              borderRadius: '6px',
                            }}
                            id="productImage4"
                            name="productImage4"
                            type="file"
                            onChange={handleFileChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={12}>
                        <FormGroup>
                          <Label for="productDescription">Product Description</Label>
                          <Input
                            id="productDescription"
                            name="productDescription"
                            type="textarea"
                            placeholder="Enter Description"
                            value={formData.productDescription}
                            onChange={handleInputChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Button
                        color="secondary"
                        onClick={() => {
                          navigate('/admin/academic');
                        }}
                      >
                        Cancel
                      </Button>

                      {loading ? (
                        <div>Loading...</div> // You can replace this with a loader component
                      ) : (
                        <Button
                          color="primary"
                          type="submit"
                          style={{
                            float: 'right',
                            marginLeft: '5%',
                            backgroundColor: '#080278',
                            color: 'white',
                            border: 'none',
                          }}
                        >
                          Save
                        </Button>
                      )}
                    </div>
                  </Form>
                </div>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default AddProduct;
